"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throwError = void 0;
function throwError(message) {
    throw new Error(message);
}
exports.throwError = throwError;
//# sourceMappingURL=throw-error.js.map